import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { sendEmailVerification } from "firebase/auth";
import "../styles/email-verification.css";
import { getCurrentUser, navigateBasedOnRole } from "../utilities/auth/authUtils";

// --- Assets --- //
import logo from "../assets/vert-cert-logo.png";
import HomeIcon from '@mui/icons-material/Home';
import LoginIcon from '@mui/icons-material/Login';

const EmailVerification = () => {
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const { email } = location.state || {};

    // Function to resend the verification email
    const onSendEmailVerification = async () => {
        setError(""); // Clear previous errors
        const user = auth.currentUser;
        try {
            if (user) {
                await sendEmailVerification(user);
                setError("Verification email resent. Please check your inbox.");
            } else {
                setError("No user is currently signed in.");
            }
        } catch (err) {
            setError("Failed to resend verification email. Please try again.");
            console.error(err);
        }
    };

    // Function to check if the user is verified
    const checkEmailVerification = async () => {
        const user = await getCurrentUser();
        try {
            await user.reload(); // Refresh user info
            if (user.emailVerified) {
                navigateBasedOnRole(user, navigate, email, setError)
            }
        } catch (err) {
            console.error("Error checking email verification:", err);
        }
    };

    // Periodically check email verification on component load
    useEffect(() => {
        const interval = setInterval(() => {
            if (getCurrentUser()) {
                checkEmailVerification();
            }
        }, 3000); // Check every 5 seconds

        return () => clearInterval(interval); // Cleanup on component unmount
    }, []);

    return (
        <div className="login-page">
            <div className="login-window">
                <a href="/"><img src={logo} alt="Vert Cert Logo" className="logo" /></a>
                <a href="/login" className="login-link"><LoginIcon /></a>
                <a href="/" className="home-link"><HomeIcon /></a>
                <h2 className="login-title">Verify Email</h2>
                {error && <p className="error-message">{error}</p>}
                <p>An email has been sent to {email}. Please check your inbox.</p>
                <button onClick={onSendEmailVerification}>Resend Verification Email</button>
            </div>
        </div>
    );
};

export default EmailVerification;